import Unauthorized from './components/Errors/Unauthorized';
import Login from './components/Login/Login';
import UserManagement from './components/UserManagement/UserManagement';
import TaskList from './components/TaskList/TaskList';
import TaskDetail from './components/TaskDetail/TaskDetail';
import NotFound from './components/Errors/NotFound';

const routes = [
  {
    path: '/',
    exact: true,
    component: Login,
    private: false
  },
  {
    path: '/task-list',
    exact: true,
    component: TaskList,
    private: true
  },
  {
    path: '/task-detail/:taskId',
    exact: true,
    component: TaskDetail,
    private: true
  },
  {
    path: '/manage-users',
    exact: true,
    component: UserManagement,
    private: true
  },
  {
    path: '/unauthorized',
    exact: true,
    component: Unauthorized,
    private: true
  },
  {
    path: '/not-found',
    exact: true,
    component: NotFound,
    private: true
  }
];

export default routes;
